// Explore-stats page: Prime Ministers.
// Recreates the Handbook page — PMs by party & cumulative length of
// service, number of PMs by party, and a name/party/period table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatBar } from './charts';

export default function PrimeMinisters() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('prime-ministers');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const c = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Prime Ministers"
      description={`Australia's Prime Ministers${
        c.total ? ` (${c.total})` : ''
      } — Liberal PMs have cumulatively served longer than Labor, and long-serving PMs such as Menzies stand out.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="prime-ministers"
    >
      {data && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Prime ministers by party and length of service (years)
              </Typography>
              <StatBar data={c.by_party_service || []} xKey="party"
                       yKey="years" layout="vertical" height={340} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Number of Prime ministers by party
              </Typography>
              <StatBar data={c.count_by_party || []} xKey="party"
                       yKey="count" layout="vertical" height={340} />
            </Paper>
          </Grid>
        </Grid>
      )}
    </ExploreStatsPage>
  );
}
